export function AccessDenied() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background px-4">
      <div className="max-w-md text-center">
        <h1 className="font-heading text-2xl text-primary mb-4">Accès non autorisé</h1>
        <p className="font-body text-muted-foreground mb-6">
          Votre compte n&apos;est pas autorisé à accéder au portail Pragmelis 365.
          Si vous pensez qu&apos;il s&apos;agit d&apos;une erreur, contactez votre administrateur.
        </p>
        <a
          href="mailto:support@pragmelis.com"
          className="inline-block px-6 py-2 bg-primary text-white font-body rounded hover:bg-accent transition-colors"
        >
          Contacter le support
        </a>
      </div>
    </div>
  )
}
